routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.categorySales', {
      url: "/categories/sales/{productSale}",
      template: `<category-products sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.categorySlugProducts', {
      url: "/categories-slug/{categorySlug}/products",
      template: `<category-products sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.productSearch', {
      url: "/categories-search/{searchText}/products",
      template: `<category-products sh-ctrl="shCtrl"></category-products>`
    })
    .state('home.categoryIdProducts', {
      url: "/categories-id/{idCategory}/products",
      template: `<category-products sh-ctrl="shCtrl"></category-products>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category-products/category-products.config.js
 **/